import { Injectable } from '@angular/core';
import { Telecom, TelecomAPIResponse } from '../interfaces/telecom';


@Injectable({
  providedIn: 'root'
})

export class TelecomAdapter {

    
  public adapterToModel(telecomFHIR: TelecomAPIResponse[]): Telecom {
    const telecom: Telecom = {
      email: null,
      phone: null,
      mobile: null
    };

    telecomFHIR.forEach(({ value, system }) => {
      if (system === 'email') {
        telecom.email = value;
      } else if (system === 'phone') {
        telecom.phone = value;
      } else if (system === 'mobile') {
        telecom.mobile = value;
      }
    });

    return telecom;
  }
  

  public adaptToAPIFormat(email?: string, phone?: string, mobile?: string): TelecomAPIResponse[] {
    const telecom: TelecomAPIResponse[] = [];

    if (email) {
      telecom.push({ system: 'email', use: 'work', value: email });
    }

    if (phone) {
      telecom.push({ system: 'phone', use: 'work', value: phone });
    }

    if (mobile) {
      telecom.push({ system: 'mobile', use: 'work', value: mobile });
    }

    return telecom;
  }


}